import { render, staticRenderFns } from "./RequisicaoForm.vue?vue&type=template&id=897a12b6&"
import script from "./RequisicaoForm.vue?vue&type=script&lang=js&"
export * from "./RequisicaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports